import { QuestInterface } from "@swivl/swivl-lib";

import { Surface } from "@jsplumbtoolkit/browser-ui";
import { BrowserUIReact } from "@jsplumbtoolkit/browser-ui-react";

import "./EditorSidePanel.scss";
import { InspectorPanel } from "./Inspector/InspectorPanel";
import { MultiSelectPanel } from "./MultiSelectPanel/MultiSelectPanel";
import NodePalette from "./NodePallet/NodePalette";
import TestQuestView from "./TestMode/TestQuestView";

interface Props {
  toolkit: BrowserUIReact;
  canEdit: boolean;
  quest: QuestInterface;

  showControls: boolean;
  surface: Surface;
  selectedNode?: Node;
  selectedNodes: Node[];

  inTestMode: boolean;
  updateNode(node: Node, originalNode?: Node, forceRedraw?: boolean): void;
  deleteNodes(nodeOrNodes: Node | Node[]): void;
  duplicateNode?(nodeId: string): void;
  duplicateNodes(nodeIds: string[]): void;
  duplicateNodesToQuest?(nodeIds: string[], targetQuestSlug: string): Promise<void>;
  saveQuest(): void;
}

export function EditorSidePanel(props: Props) {
  const { showControls, quest, toolkit, surface, selectedNode, updateNode, deleteNodes, inTestMode, selectedNodes, canEdit } = props;

  return (
    <div className="EditorSidePanel" id="EditorSidePanel">
      {canEdit && showControls && <NodePalette surface={surface} quest={quest} />}
      <InspectorPanel
        selectedNode={selectedNode}
        updateNode={updateNode}
        deleteNodes={deleteNodes}
        duplicateNode={props.duplicateNode}
        canEdit={canEdit}
      />
      {inTestMode && <TestQuestView selectedQuest={quest} />}
      {selectedNodes && selectedNodes.length > 1 && (
        <MultiSelectPanel
          saveQuest={props.saveQuest}
          toolkit={toolkit}
          quest={quest}
          deleteNodes={deleteNodes}
          duplicateNodes={props.duplicateNodes}
          duplicateNodesToQuest={props.duplicateNodesToQuest}
          selectedNodes={selectedNodes}
          canEdit={canEdit}
        />
      )}
    </div>
  );
}
